import axios from "axios";
import config from "../config";

const API_DOCUMENTATION_SERVICE = config.api_documentation_service;

const ApiDataService = {
  // @name getAllMetadata
  // @desc api service to get metadata json for UI content
  // @author Ramya
  getAllMetadata: () => {
    const headers = {
      "Content-Type": "application/json",
    };
    return axios.get(`${API_DOCUMENTATION_SERVICE}`, { headers });
  },

  getURLContent: (url) => {
    return axios.get(`${url}`);
  },
};

export default ApiDataService;
